import type { CommonStylesPalette } from '../types.d';

export const getBudgetCenterTooltipStyle = () => ({
  '#budget-center-help-tooltip-id .popover-content': {
    padding: '24px',
  },

  '#budget-center-help-tooltip-id .popover-content .budget-center-help-tooltip': {
    marginBottom: '8px',
  },
});

export const getBudgetCenterEntryValueStyle = ({ palette = {} as CommonStylesPalette }) => ({
  '& .performance-metrics-value .budget-center-entry': {
    borderBottom: `1px dashed ${palette.themePrimary}`,
  },
});

export const campaignGridBudgetCenterEntryStyle = ({ palette = {} as CommonStylesPalette }) => ({
  '& span.combinedBudgetGridCellValue.budgetCenterEntry': {
    borderBottom: palette.themePrimary ? `1px dashed ${palette.themePrimary}` : '1px dashed #0078d4',
  },
});
